import HeaderTile from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import setBodyOverflow from 'utils/setBodyOverflow';

import AccountSettings from './AccountSettings';
import BankAccounts from './BankAccounts';
import CompanyFees from './CompanyFees';
import PaymentProfiles from './PaymentProfiles';
import PublicInformation from './PublicInformation';

const CompanyDetail = () => {
  const { merchantId } = useParams<{ merchantId: string }>();

  useEffect(() => {
    setBodyOverflow('auto');
  }, []);

  return (
    <>
      <HeaderTile title="Merchant Details" />
      <Content className="merchant-details-content">
        <AccountSettings merchantId={merchantId} />
        <PublicInformation merchantId={merchantId} />
        <PaymentProfiles merchantId={merchantId} />
        <BankAccounts />
        <CompanyFees merchantId={merchantId} />
      </Content>
    </>
  );
};

export default CompanyDetail;
